import { render } from "./IncludedContent.vue?vue&type=template&id=b6c0e394&scoped=true"
import script from "./IncludedContent.vue?vue&type=script&lang=js"
export * from "./IncludedContent.vue?vue&type=script&lang=js"

import "./IncludedContent.vue?vue&type=style&index=0&id=b6c0e394&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6c0e394"]])

export default __exports__